import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import Confetti from "@/components/Confetti";
import { billingApi } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Check, Loader2, ArrowRight } from "lucide-react";

export default function CartSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refresh } = useCart();
  const [state, setState] = useState({ status: "polling", payment_status: "pending" });
  const [confetti, setConfetti] = useState(false);
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState({ status: "error" }); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      tries.current += 1;
      try {
        const r = await billingApi.status(sessionId);
        if (cancelled) return;
        setState(r);
        if (r.payment_status === "paid") {
          setConfetti(true);
          setTimeout(() => setConfetti(false), 1800);
          refresh();
          return;
        }
        if (r.status === "expired" || tries.current >= 8) return;
      } catch (e) { /* keep polling */ }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, refresh]);

  const paid = state.payment_status === "paid";

  return (
    <div className="min-h-screen relative overflow-hidden">
      {confetti && <Confetti />}
      <NavBar />
      <div className="max-w-2xl mx-auto px-5 lg:px-10 py-20 relative">
        {paid ? (
          <div className="card-x card-green bg-[#15FF73] p-10 text-center">
            <Check size={42} strokeWidth={3} className="mx-auto mb-3" />
            <h1 className="font-display text-5xl font-extrabold mb-3">Paid in full.</h1>
            <p className="mb-6">${state.amount?.toFixed(2)} · cart locked, your shops have been notified.</p>
            <Link to="/me" className="btn-x btn-primary">My orders <ArrowRight size={14} strokeWidth={2.4} /></Link>
          </div>
        ) : (
          <div className="card-x card-cyan bg-[#FAF6E8] p-10 text-center">
            <Loader2 size={36} className="mx-auto mb-3 animate-spin" />
            <h1 className="font-display text-4xl font-extrabold">Confirming payment…</h1>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
